/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { SubmitCompletedWorkflowOfPaymentRequestsRequestEvidence } from './submit-completed-workflow-of-payment-requests-request-evidence';
// May contain unused imports in some cases
// @ts-ignore
import { SubmitCompletedWorkflowOfPaymentRequestsRequestSupplier } from './submit-completed-workflow-of-payment-requests-request-supplier';

/**
 * 
 * @export
 * @interface SubmitCompletedWorkflowOfPaymentRequestsRequest
 */
export interface SubmitCompletedWorkflowOfPaymentRequestsRequest {
    /**
     * 
     * @type {SubmitCompletedWorkflowOfPaymentRequestsRequestSupplier}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequest
     */
    'supplier': SubmitCompletedWorkflowOfPaymentRequestsRequestSupplier;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequest
     */
    'dueDate': string;
    /**
     * 
     * @type {number}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequest
     */
    'totalAmount': number;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequest
     */
    'transferFeeResponsibility': SubmitCompletedWorkflowOfPaymentRequestsRequestTransferFeeResponsibilityEnum;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequest
     */
    'memo': string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequest
     */
    'withholdingCalculatingMethod': SubmitCompletedWorkflowOfPaymentRequestsRequestWithholdingCalculatingMethodEnum;
    /**
     * 
     * @type {number}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequest
     */
    'withholdingAmount': number | null;
    /**
     * 
     * @type {SubmitCompletedWorkflowOfPaymentRequestsRequestEvidence}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequest
     */
    'evidence': SubmitCompletedWorkflowOfPaymentRequestsRequestEvidence;
}

export const SubmitCompletedWorkflowOfPaymentRequestsRequestTransferFeeResponsibilityEnum = {
    self: 'SELF',
    supplier: 'SUPPLIER'
} as const;

export type SubmitCompletedWorkflowOfPaymentRequestsRequestTransferFeeResponsibilityEnum = typeof SubmitCompletedWorkflowOfPaymentRequestsRequestTransferFeeResponsibilityEnum[keyof typeof SubmitCompletedWorkflowOfPaymentRequestsRequestTransferFeeResponsibilityEnum];
export const SubmitCompletedWorkflowOfPaymentRequestsRequestWithholdingCalculatingMethodEnum = {
    none: 'NONE',
    manuscriptOrLecture: 'MANUSCRIPT_OR_LECTURE',
    lawyerOrCpa: 'LAWYER_OR_CPA',
    judicialScrivener: 'JUDICIAL_SCRIVENER',
    other: 'OTHER'
} as const;

export type SubmitCompletedWorkflowOfPaymentRequestsRequestWithholdingCalculatingMethodEnum = typeof SubmitCompletedWorkflowOfPaymentRequestsRequestWithholdingCalculatingMethodEnum[keyof typeof SubmitCompletedWorkflowOfPaymentRequestsRequestWithholdingCalculatingMethodEnum];


